import { ImageName, images } from "./images";

type Props = {
  name: ImageName;
  className?: string;
};

export function Image({ name, className }: Props) {
  const src = images[name];
  return <img src={src} className={className} />;
}
export type { ImageName } from "./images";
